/**
 * Shared constants for display components
 */

export const BUTTON_RADIUS = 80;
